<canvas id="rc_canvas" tabindex="0" class="rc-canvas" width="1000" height="1000"
    style="cursor: none; width: 100%; height: 100%;"
    [ngClass]="{'no-input': !supportsInput }"
    (click)="emitSetFocus({ $event: $event })"></canvas>